import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { labelCls, inputCls, primaryBtn, errorCls } from "./diaryStyles";

export const PasswordSignIn = ({ defaultUsername, onSuccess, onForgotPassword, onCreate }) => {
  const { login } = useAuth();
  const [username, setUsername] = useState(defaultUsername || "");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!username.trim() || !password) { setError("Enter your username and password."); return; }
    setLoading(true);
    try {
      onSuccess(await login(username.trim(), password));
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(d === "trial_expired" ? "This account has been permanently deleted after the trial ended." : formatApiErrorDetail(d) || "Could not sign in.");
    } finally { setLoading(false); }
  };

  return (
    <form onSubmit={submit} data-testid="diary-signin-form">
      <label className={labelCls}>Username</label>
      <input data-testid="diary-username" value={username} onChange={(e) => setUsername(e.target.value.trim())} placeholder="Your username" autoComplete="username" className={inputCls} />
      <label className={`${labelCls} mt-3`}>Password</label>
      <input data-testid="diary-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter your password" autoComplete="current-password" className={inputCls} />
      {error && <p data-testid="diary-error" className={errorCls}>{error}</p>}
      <button data-testid="diary-signin" type="submit" disabled={loading} className={primaryBtn}>{loading ? "Signing in…" : "Sign in"}</button>
      <button data-testid="diary-forgot-password" type="button" onClick={() => onForgotPassword(username)} className="mt-2 block py-2 text-sm font-semibold text-[#F2D493] underline underline-offset-2 hover:text-white">Forgot password?</button>
      <div className="mt-4 border-t border-white/15 pt-4">
        <p className="text-center text-[13px] text-[#D6ECEE]">New here?</p>
        <button type="button" data-testid="diary-create" onClick={onCreate} className="mt-2 w-full rounded-full border-2 border-white/70 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-white/10">Create an account</button>
      </div>
    </form>
  );
};
